module.exports = __webpack_public_path__ + "static/media/3-ply.72d80b56.png";